import styled from 'styled-components';

export const NonShrinkWrapper = styled.div`
  flex-shrink: 0;
  position: relative;
`;
